module.exports = __webpack_public_path__ + "img/ZWF_Akash_Julia.0a825db1.jpg";